import { render, staticRenderFns } from "./default-settings-page.vue?vue&type=template&id=3179234c&scoped=true&"
import script from "./default-settings-page.vue?vue&type=script&lang=js&"
export * from "./default-settings-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179234c",
  null
  
)

export default component.exports